<template>
  <div class="view-change-password">
    <slot name="txtBefore"><h2>Password</h2></slot>
    <div class="maskedPassword">
      <b-row class="password">
        <b-col md="" sm="12" class="label">
          <slot name="labelPassword">Passwort</slot>
        </b-col>
        <b-col md="" sm="12" class="value"><slot name="txtPasswordMask">*******</slot></b-col>
      </b-row>
    </div>
    <Stepper
      :show-prev="false"
      @next="next()"
    >
      <template #btnNext><slot name="btnNext">ändern</slot></template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import processSteps from '../../../../../mixins/processSteps'
import Stepper from '../../../../generic/Stepper.vue'
import { mapMutations } from 'vuex'
import { BRow, BCol } from 'bootstrap-vue'

export const stepName = 'view'

export default {
  name: 'ViewChangePassword',
  components: {
    Stepper, BRow, BCol
  },
  mixins: [
    processSteps(stepName, stepName, stepName) // do no jump by default. configure steps by props of processStep
  ],
  methods: {
    ...mapMutations('changePassword', [
      'changeStep'
    ]),
    next () {
      this.changeStep({ step: this.nextStep })
    }
  }
}
</script>
